import { Modal, Spin, Tag, Typography } from "antd";
import { useQuery } from "react-query";
import moment from "moment";
import { getSubjectStatusHistory } from "../../Requests/subject-requests";
import { SubjectStatusEnum } from "../../Api";

interface SubjectStatusHistoryModalProps {
    open: boolean;
    subjectId: string;
    subjectName?: string;
    onCancel: () => void;
    statusColors: (status: SubjectStatusEnum) => string | undefined;
    statusToString: (status: SubjectStatusEnum) => string | undefined;
}

const SubjectStatusHistoryModal = ({ open, subjectId, subjectName, onCancel, statusColors, statusToString }: SubjectStatusHistoryModalProps) => {
    const { data, isLoading } = useQuery(
        ["getSubjectStatusHistory", subjectId],
        () => getSubjectStatusHistory(subjectId),
        { enabled: open && !!subjectId, refetchOnWindowFocus: false }
    );

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            title={`Istoric status${subjectName ? ' — ' + subjectName : ''}`}
            width="600px"
        >
            {isLoading ? (
                <Spin />
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: '60vh', overflowY: 'auto' }}>
                    {(!data || data.length === 0) && (
                        <Typography>Nu există istoric pentru această fișă de disciplină.</Typography>
                    )}
                    {(data ?? []).map((entry, index) => (
                        <div key={index} style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '8px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Tag color={statusColors(entry.status ?? SubjectStatusEnum.Draft)}>
                                    {statusToString(entry.status ?? SubjectStatusEnum.Draft)}
                                </Tag>
                                <Typography.Text type="secondary">
                                    {entry.userName}{entry.createdAt ? ' — ' + moment(entry.createdAt).format('DD.MM.YYYY HH:mm') : ''}
                                </Typography.Text>
                            </div>
                            {entry.message && (
                                <Typography style={{ marginTop: '4px', whiteSpace: 'pre-wrap' }}>{entry.message}</Typography>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </Modal>
    );
};

export default SubjectStatusHistoryModal;
